import { render, staticRenderFns } from "./ReferralLeakageAuditLeadsPage.vue?vue&type=template&id=423c9f66&scoped=true"
import script from "./ReferralLeakageAuditLeadsPage.vue?vue&type=script&lang=js"
export * from "./ReferralLeakageAuditLeadsPage.vue?vue&type=script&lang=js"
import style0 from "./ReferralLeakageAuditLeadsPage.vue?vue&type=style&index=0&id=423c9f66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c9f66",
  null
  
)

export default component.exports